import React from "react";
import { connect, useDispatch } from "react-redux";
import { get } from "lodash";
// import Keycloak from "keycloak-js";
// import { isMobile } from "react-device-detect";
import { setHttpErrObj, setCookie } from '../helpers'

const Signer = ({ keycloak }) => {
  const dispatch = useDispatch()
  console.log("keycloak.authenticated" , keycloak.authenticated)
  if (keycloak.authenticated) {
    fetchToken(keycloak, dispatch);
  } else {
    if (keycloak.authenticated === false) {
      window.location.href = keycloak.createLoginUrl() + '&clear=true';
      //   console.log(keycloak.createLoginUrl());
    }
  }
  return <></>;
};

function fetchToken(keycloak, dispatch) {
  var redirect = new URLSearchParams(window.location.search).get("redirect");
  if (redirect === null || !isAllowUrls(redirect)) {
    window.location.href = "404.html";
  }
  fetch(window._env_.subscriberServiceBaseURL + "/v1/token", {
    headers: {
      Authorization: "Bearer " + keycloak.idToken,
    },
  })
    .then((raw) => raw.json())
    .then((data) => {
      localStorage.setItem("vtoken", data.token)
      window.location.href = `${redirect}?jwt=${data.token}`;
      // console.log(redirect + "?jwt=" + data.token)
    }).catch((error) => {
      console.error('Signer', error)
      const errorObj = setHttpErrObj("fetchToken", error.message, "fetchToken: status bad request")
      setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
      window.location.href = `/portal/error?errorCode=500&message=error_text_1&setLog=true`
    })
}
function isAllowUrls(redirect) {
  var urlsEnv = window._env_.TOKEN_ALLOW_URLS;
  if (urlsEnv === null) {
    return true;
  }
  var allowUrls = [...urlsEnv.split(",")]; // ["http://google.co", "http://pantip.c"];

  if (redirect.startsWith('http://') || redirect.startsWith('https://')) {
    if (allowUrls === null || allowUrls.length === 0) {
      return true;
    }

    for (let index = 0; index < allowUrls.length; index++) {
      const url = allowUrls[index];
      if (redirect.startsWith(url)) {
        return true;
      }
    }
    return false;
  }
  return true;
}

const mapStateToProps = (state) => ({
  keycloak: get(state, "keycloak", ""),
});

export default connect(mapStateToProps)(Signer);
